import instance from "./Request";

export const getAdminCondiments = async (branch_id) => {
  const request = await instance();
  const data = await request
    .post("/api/admin/admin_condiments", { branch_id })
    .catch((error) => ({ error }));

  return data;
};

export const getCondimentItems = async ({ id, type }) => {
  const request = await instance();
  const data = await request
    .post("/api/admin/list_condiments", { id, type })
    .catch((error) => ({ error }));

  return data;
};

export const updateCondimentStatus = async ({
  id,
  status_mode,
  status_value,
  type,
  user,
}) => {
  const request = await instance();
  const data = await request
    .post("/api/admin/condiment_status", {
      id,
      status_mode,
      status_value,
      type,
      user,
    })
    .catch((error) => ({ error }));

  return data;
};

export const updateCondimentOrder = async ({
  parent_id,
  type,
  user,
  items,
}) => {
  const request = await instance();
  const data = await request
    .post("/api/condiment_order", {
      parent_id,
      type,
      user,
      items,
    })
    .catch((error) => ({ error }));

  return data;
};
